<template>
    <div class="form-group">
        <div class="position-relative">
            <input
                :id="id"
                ref="input"
                :autocomplete="autocomplete"
                class="form-control pr-1"
                :class="{'is-invalid': errors !== undefined}"
                :value="value"
                :max="max"
                :min="min"
                :type="type"
                :maxlength="maxlength"
                :placeholder="placehoder"
                :disabled="disabled"
                :readonly="readonly"
                @input="$emit('input', $event.target.value)"
                @keyup="$emit('keyup', $event.target.value)"
            >

            <label
                v-if="$slots.default"
                :for="id"
                :class="{ active: value || value === 0 || type === 'date' || showLabel }"
            >
                <slot />
            </label>

            <transition name="fade">
                <i
                    v-if="searching"
                    class="select-arrow fa fa-circle-notch fa-spin"
                />
            </transition>

            <i
                v-if="euros"
                class="fa fa-euro-sign select-arrow"
            />

            <i
                v-else-if="percents"
                class="fa fa-percent select-arrow"
            />
        </div>

        <base-error :errors="errors" />
    </div>
</template>

<script>
    import FormElement from '../../mixins/FormElement'
    import BaseError from './BaseError'

    export default {
        name: 'BaseInput',

        components: { BaseError },

        mixins: [FormElement],

        props: {
            placehoder: {type: String, default: ''},
            disabled: Boolean,
            readonly: Boolean,
            focus: Boolean,
            type: {type: String, default: 'text'},
            autocomplete: {type: String, default: null},
            showLabel: {type: Boolean, default: false},
            min: {type: [String, Number], default: null},
            max: {type: [String, Number], default: null},
            maxlength: {type: Number, default: null},
            euros: Boolean,
            percents: Boolean,
            searching: Boolean,
        },

        mounted: function() {
            if (this.focus) {
                this.$refs.input.focus()
            }
        },
    }
</script>
